<template>
	<div id="authors">
		<div class="tag" v-for="author in sortedAuthors" v-bind:key="author.id" @click="selectAuthor(author)">
			{{ author.title }}
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex";
	import {orderBy} from "natural-orderby";

	export default {
		computed: {
			...mapState([ "authors", "authorsSongs" ]),
			sortedAuthors() {
				return orderBy(Object.values(this.authors), v => v.title);
			}
		},
		methods: {
			selectAuthor(author) {
				this.$store.commit("setSongsFilter", {
					playlist: null,
					author: author.id,
					onlyQueue: false
				});
				this.$store.commit("setRootSideOpened", false);
				this.$store.commit("setExternalSearchOpened", false);
			},
		}
	}

</script>

<style lang="scss" scoped>
	#authors {
		padding-bottom: 20px;
	}
</style>
